import type { IconNode } from '../types';

/**
 * @name credit-card-x
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIuNSAxOUg0YTIgMiAwIDAxLTItMlY3YTIgMiAwIDAxMi0yaDE2YTIgMiAwIDAxMiAydjMuNSIgLz4KICA8cGF0aCBkPSJNMiAxMGgyMCIgLz4KICA8cGF0aCBkPSJNNiAxNGgyIiAvPgogIDxwYXRoIGQ9Im0xNi41IDE0LjUgNSA1IiAvPgogIDxwYXRoIGQ9Im0yMS41IDE0LjUtNSA1IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/credit-card-x
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const CreditCardX: IconNode = [
  ['path', { d: 'M12.5 19H4a2 2 0 01-2-2V7a2 2 0 012-2h16a2 2 0 012 2v3.5' }],
  ['path', { d: 'M2 10h20' }],
  ['path', { d: 'M6 14h2' }],
  ['path', { d: 'm16.5 14.5 5 5' }],
  ['path', { d: 'm21.5 14.5-5 5' }],
];

export default CreditCardX;
